import type { SVGProps } from 'react';

export function PawIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.194 5.884c.536 1.609-.012 3.232-1.223 3.63S7.343 8.929 6.806 7.32s.011-3.232 1.223-3.63c1.211-.397 2.629.585 3.165 2.194M6.165 9.848c.709 1.215.536 2.628-.383 3.153-.918.525-2.238-.033-2.943-1.248s-.536-2.63.382-3.154c.919-.525 2.239.034 2.944 1.249m-1.17 7.597C6.96 12.146 10.451 10.8 12 10.8s5.04 1.346 7.005 6.645c.135.364.195.754.195 1.144v.06a1.75 1.75 0 0 1-1.751 1.751q-.65 0-1.275-.157l-3.3-.825a3.6 3.6 0 0 0-1.748 0l-3.3.825a5.2 5.2 0 0 1-1.275.157A1.75 1.75 0 0 1 4.8 18.65v-.06c0-.39.06-.78.195-1.144m13.223-4.444c-.92-.525-1.092-1.938-.383-3.153s2.025-1.774 2.944-1.25c.919.526 1.091 1.94.382 3.155S19.136 13.526 18.218 13m-4.19-3.487c-1.21-.398-1.758-2.021-1.222-3.63.537-1.609 1.954-2.591 3.165-2.194s1.759 2.021 1.223 3.63c-.537 1.609-1.954 2.591-3.165 2.194" />
    </svg>
  );
}
